import { ref, watch, computed } from '@vue/composition-api'
import axios from '@axios'
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useEmployeeList(isTemplate) {
  const refDocumentListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'name', label: i18nT(`Name`), sortable: true, thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'bank', label: i18nT(`Bank`), sortable: true },
    { key: 'iban', label: i18nT(`Iban`), sortable: true },
    { key: 'bic', label: i18nT(`Bic`), sortable: true },
    { key: 'currency', sortable: true },
    { key: 'balance', label: i18nT(`Balance`), sortable: true },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ]
  const perPage = ref(10)
  const totalDocuments = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const accounts = ref([])
  const bankCurrency = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refDocumentListTable.value
      ? refDocumentListTable.value.localItems.length
      : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDocuments.value,
    }
  })

  const refetchData = () => {
    refDocumentListTable.value.refresh()
  }

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      bankCurrency,
    ],
    () => {
      refetchData()
    }
  )

  const fetchDocuments = (ctx, callback) => {
    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value
    }

    if (bankCurrency.value != null) {
      params['filters[currency]'] = bankCurrency.value
    }

    axios
      .get(`bankaccounts`, {
        params,
      })
      .then(({ data }) => {
        if (data.data.bank_accounts) {
          accounts.value = data.data.bank_accounts
          callback(data.data.bank_accounts)
        } else {
          accounts.value = []
          callback([])
        }

        totalDocuments.value = data.data.pagination.records_count
      })
  }

  return {
    fetchDocuments,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    bankCurrency,
    accounts,
    refetchData,
  }
}
